var testMsg = "Ready...";
console.log(testMsg);
